import styled from "styled-components";
export const HelpIconContainer = styled.div.withConfig({
  displayName: "help-iconstyles__HelpIconContainer",
  componentId: "sc-1klanu5-0"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  alignItems: "baseline"
});
export const HelpIconChildrenContainer = styled.div.withConfig({
  displayName: "help-iconstyles__HelpIconChildrenContainer",
  componentId: "sc-1klanu5-1"
})(["", " ", ""], ({
  position
}) => position === "right" ? {
  marginRight: "0.5rem"
} : {
  marginLeft: "0.5rem"
}, {
  display: "flex"
});
